import { render, staticRenderFns } from "./InsCmsCat4.vue?vue&type=template&id=13358f3b&scoped=true&"
import script from "./InsCmsCat4.vue?vue&type=script&lang=ts&"
export * from "./InsCmsCat4.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsCat4.vue?vue&type=style&index=0&lang=less&"
import style1 from "./InsCmsCat4.vue?vue&type=style&index=1&id=13358f3b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13358f3b",
  null
  
)

export default component.exports